import { render, staticRenderFns } from "./PublicTransportService.vue?vue&type=template&id=1a34c1b8&scoped=true&"
import script from "./PublicTransportService.vue?vue&type=script&lang=js&"
export * from "./PublicTransportService.vue?vue&type=script&lang=js&"
import style0 from "./PublicTransportService.vue?vue&type=style&index=0&id=1a34c1b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a34c1b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
